<template>
  <a href="#" class="btn-followed" :class="`button-` + icon">
    <span class="btn-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 30 24"
        v-if="icon === 'follow'"
      >
        <path
          d="M29.25,9.75h-3v-3A.752.752,0,0,0,25.5,6H24a.752.752,0,0,0-.75.75v3h-3a.752.752,0,0,0-.75.75V12a.752.752,0,0,0,.75.75h3v3a.752.752,0,0,0,.75.75h1.5a.752.752,0,0,0,.75-.75v-3h3A.752.752,0,0,0,30,12V10.5A.752.752,0,0,0,29.25,9.75ZM10.5,12a6,6,0,1,0-6-6A6,6,0,0,0,10.5,12Zm4.2,1.5h-.783a8.16,8.16,0,0,1-6.834,0H6.3A6.3,6.3,0,0,0,0,19.8v1.95A2.251,2.251,0,0,0,2.25,24h16.5A2.251,2.251,0,0,0,21,21.75V19.8A6.3,6.3,0,0,0,14.7,13.5Z"
          fill="#1ca54c"
        />
      </svg>
      <svg class="svg-icon" viewBox="0 0 20 20" v-else-if="icon === 'sent'">
        <path
          fill="#777"
          d="M17.218,2.268L2.477,8.388C2.13,8.535,2.164,9.05,2.542,9.134L9.33,10.67l1.535,6.787c0.083,0.377,0.602,0.415,0.745,0.065l6.123-14.74C17.866,2.46,17.539,2.134,17.218,2.268 M3.92,8.641l11.772-4.89L9.535,9.909L3.92,8.641z M11.358,16.078l-1.268-5.613l6.157-6.157L11.358,16.078z"
        ></path>
      </svg>

      <svg
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="verifiedIconTitle"
        stroke="#349E4D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        v-else-if="icon === 'followed'"
      >
        <path d="M8 12.5L10.5 15L16 9.5" />
        <path
          d="M12 22C13.2363 22 14.2979 21.2522 14.7572 20.1843C14.9195 19.8068 15.4558 19.5847 15.8375 19.7368C16.9175 20.1672 18.1969 19.9453 19.0711 19.0711C19.9452 18.1969 20.1671 16.9175 19.7368 15.8376C19.5847 15.4558 19.8068 14.9195 20.1843 14.7572C21.2522 14.2979 22 13.2363 22 12C22 10.7637 21.2522 9.70214 20.1843 9.24282C19.8068 9.08046 19.5847 8.54419 19.7368 8.16246C20.1672 7.08254 19.9453 5.80311 19.0711 4.92894C18.1969 4.05477 16.9175 3.83286 15.8376 4.26321C15.4558 4.41534 14.9195 4.1932 14.7572 3.8157C14.2979 2.74778 13.2363 2 12 2C10.7637 2 9.70214 2.74777 9.24282 3.81569C9.08046 4.19318 8.54419 4.41531 8.16246 4.26319C7.08254 3.83284 5.80311 4.05474 4.92894 4.92891C4.05477 5.80308 3.83286 7.08251 4.26321 8.16243C4.41534 8.54417 4.1932 9.08046 3.8157 9.24282C2.74778 9.70213 2 10.7637 2 12C2 13.2363 2.74777 14.2979 3.81569 14.7572C4.19318 14.9195 4.41531 15.4558 4.26319 15.8375C3.83284 16.9175 4.05474 18.1969 4.92891 19.0711C5.80308 19.9452 7.08251 20.1671 8.16243 19.7368C8.54416 19.5847 9.08046 19.8068 9.24282 20.1843C9.70213 21.2522 10.7637 22 12 22Z"
        />
      </svg>
    </span>
    <span class="btn-label">{{ $t(text) }}</span>
  </a>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "connect",
    },
    icon: {
      type: String,
      default: "connect",
    },
  },
};
</script>

<style lang="scss" scoped>
.button-sent {
  border: 1px solid #777 !important;
  color: #777 !important;
  background: rgba(119, 119, 119, 0.04) !important;
}

.button-sent:hover {
  background: rgb(119, 119, 119) !important;
  color: #fff !important;
}
.btn-followed {
  display: flex;
  align-items: center;
  width: 140px;
  height: 34px;
  border: 2px solid var(--green-color);
  border: 1px solid #4646461f;
  border-radius: 17px;
  padding-right: 10px;
  color: var(--green-color);
  font-size: 16px;

  &:hover {
    background: var(--green-color);
    border: 1px solid var(--green-color);
    color: #fff;
    border-color: rgba(0, 90, 31, 0.27);

    path {
      fill: #fff;
    }

    .btn-icon {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .btn-icon {
    width: 30px;
    height: 30px;
    padding: 5px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.07);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-label {
    flex-grow: 1;
    text-align: center;
  }
}
@media (max-width:600px){
.btn-followed {
  font-size: 14px;
}
}
</style>
